import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GcResultChartDataComponent } from './gc-result-chart-data/gc-result-chart-data.component';
import { GcResultSummaryDataComponent } from './gc-result-summary-data/gc-result-summary-data.component';
import { GcResultTableDataComponent } from './gc-result-table-data/gc-result-table-data.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [
    GcResultChartDataComponent,
    GcResultSummaryDataComponent,
    GcResultTableDataComponent,
  ],
  imports: [CommonModule, SharedModule, HighchartsChartModule],
  exports: [
    GcResultChartDataComponent,
    GcResultSummaryDataComponent,
    GcResultTableDataComponent,
  ],
})
export class GcHelpersModule {}
